<template>
  <div v-if="retro" class="app-bar-action">
    <v-badge
      dot
      overlap
      offset-x="6"
      offset-y="6"
      color="error"
      :value="pendiente"
    >
      <v-chip
        small
        dark
        :color="colorCalificacion"
        :title="pendiente ? 'Tienes una retroalimentación por aceptar' : 'Última calificación de retroalimentación'"
        @click="dialog = true"
      >
        <v-icon small left>mdi-star-check</v-icon>
        {{ calificacion !== null ? calificacion : '—' }}
      </v-chip>
    </v-badge>

    <v-dialog v-model="dialog" max-width="800px" scrollable>
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Mi última retroalimentación</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1 mr-2">
            <strong>ID: {{ retro.idretroalimentacion }}</strong>
          </span>
          <v-btn icon small @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
          <DetalleRetroalimentacion :retro="retro" />

          <v-card v-if="pendiente" class="shadowCard mt-4">
            <v-card-text>
              <label>Aceptar o rechazar</label>
              <v-radio-group v-model="estatusRespuesta" row hide-details>
                <v-radio label="Aceptar" :value="1"></v-radio>
                <v-radio label="Rechazar" :value="2"></v-radio>
              </v-radio-group>

              <v-textarea
                v-if="estatusRespuesta == 2"
                v-model="mensaje_rechazo"
                :rows="3"
                auto-grow
                filled
                dense
                class="mt-4"
                label="Escribe un motivo"
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                small
                tile
                color="green"
                dark
                :loading="guardando"
                @click="guardar()"
              >
                <v-icon left small>mdi-content-save</v-icon>
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
  </div>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import DetalleRetroalimentacion from '@/components/retroalimentacion/DetalleRetroalimentacion.vue'
import validarErrores from '@/mixins/validarErrores'
import { calificacionRetro, colorCalificacionRetro } from '@/constants/retroalimentacion-comercial'

export default {
  name: 'CalificacionRetroAppBar',

  mixins: [ validarErrores ],

  components: {
    Alerta,
    DetalleRetroalimentacion,
  },

  data: () => ({
    retro: null,
    dialog: false,
    estatusRespuesta: null,
    mensaje_rechazo: '',
    guardando: false,
  }),

  computed: {
    calificacion () {
      return calificacionRetro(this.retro)
    },
    colorCalificacion () {
      return colorCalificacionRetro(this.calificacion)
    },
    pendiente () {
      return !!this.retro && this.retro.estatus == 0
    },
  },

  watch: {
    dialog (val) {
      if (!val) {
        this.estatusRespuesta = null
        this.mensaje_rechazo = ''
      }
    },
  },

  created () {
    this.cargarUltima()
    this.$root.$on('retro-actualizada', this.cargarUltima)
  },

  beforeDestroy () {
    this.$root.$off('retro-actualizada', this.cargarUltima)
  },

  methods: {
    cargarUltima () {
      return this.$http.get('retroalimentacion.ultima').then(response => {
        this.retro = response.data && response.data.retro ? response.data.retro : null
      }).catch(() => {
        this.retro = null
      })
    },

    guardar () {
      if (!this.estatusRespuesta) {
        this.validarErrorDirecto('Elige si aceptas o rechazas la retroalimentación.')
        return
      }
      if (this.estatusRespuesta == 2 && !(this.mensaje_rechazo && this.mensaje_rechazo.trim())) {
        this.validarErrorDirecto('Escribe el motivo del rechazo.')
        return
      }

      const payload = {
        idretroalimentacion: this.retro.idretroalimentacion,
        mensaje_rechazo: this.estatusRespuesta == 2 ? this.mensaje_rechazo : '',
        estatus: this.estatusRespuesta,
        deleted: 0,
        validado: this.retro.validado,
      }

      this.guardando = true
      this.$http.post('retroalimentacion.update', payload).then(() => {
        this.dialog = false
        this.validarSuccess('Respuesta guardada')
        return this.cargarUltima()
      }).catch(error => {
        this.validarError(error)
      }).finally(() => { this.guardando = false })
    },
  },
}
</script>
